import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../utils/ModalEventListener";
import SingleSelectDropDown from "../../layouts/SingleSelectDropDown";
import { axios_instance } from "../../api/axios_instance";
import { toast } from "react-toastify";
import { useCallback } from "react";

const RetagDocumentModal = ({
  closeRetagModal,
  doc,
  origin = "ATS",
  lead_id,
  dis_id,
}) => {
  const [state, setState] = useState({ retag: "", tagArr: [] });
  const ref = useRef();

  const fetchData = useCallback(async () => {
    let retags = await axios_instance({
      url: "/dts/getRetagImageList",
      method: "POST",
      data: {
        origin,
        source: "",
      },
    });

    retags = retags.data.documents.map((retag, idx) => {
      const { document_name, ...newobj } = retag;
      newobj.text = document_name;
      newobj.value = idx;
      return newobj;
    });

    retags.unshift({
      text: "Select Document Tag",
      value: "",
    });

    setState((prevState) => ({ ...prevState, tagArr: retags }));
  }, [origin]);

  useEffect(() => {
    fetchData();
    return modalEventListener(ref, closeRetagModal);
  }, [closeRetagModal, fetchData]);

  const saveRetagDocument = async (e) => {
    const { retag } = state;

    if (!retag) {
      toast.dismiss();
      return toast.error("Please select new document tag", {
        theme: "colored",
      });
    }
    const { doc_lead_id, document_id, origin } = doc;
    const { doc_stage, text } = state.tagArr[parseInt(retag)];

    const newId = state.tagArr[parseInt(retag) + 1].document_id;

    try {
      const result = await axios_instance({
        url: "/dts/saveRetagDocument",
        method: "POST",
        data: {
          disbursement_id: dis_id,
          finance_lead_id: lead_id,
          retag_doc_id: document_id,
          retag_doc_lead_id: doc_lead_id,
          retag_origin: origin,
          new_tag_id: newId,
          new_tag_name: text,
          new_tag_stage: doc_stage,
          action: "save_retag_docs",
        },
      });
      if (result.status === 200) {
        toast(
          <>
            <span className="glyphicon glyphicon-ok-sign"></span> Success
          </>
        );
        closeRetagModal();
        window.location.reload();
      }
    } catch (error) {}
  };

  return ReactDOM.createPortal(
    <div className="modal-wrapper">
      <div className="retag-modal-content" ref={ref}>
        <div className="modal-header">
          <button type="button" className="close" onClick={closeRetagModal}>
            <span>&times;</span>
          </button>
          <h4 className="modal-title" id="retagHeadModal">
            Retag Document
          </h4>
        </div>
        <div className="modal-body pd-bot clearfix" id="retag_div">
          <div className="form-group">
            <label>Current Tag Name</label>
            <div>{doc.document_name}</div>
          </div>
          <label>New Tag Name</label>
          <SingleSelectDropDown
            dataArr={state.tagArr}
            name="retag_doc_gallery"
            value={state.retag}
            handleChange={(e) => setState({ ...state, retag: e.target.value })}
          />
        </div>
        <div className="modal-footer" id="retag_save_btn">
          <button
            type="button"
            className="btn rc-btn_rset pad-L20 pad-R20"
            onClick={closeRetagModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn rc-btn_primary btn-lg"
            onClick={saveRetagDocument}
          >
            Save
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default RetagDocumentModal;
